<div class="menu" *ngIf="Heading">
    <span class="menu-heading">{{ Heading }}</span>
    <span class="close" (click)="closeCaseCreation()">X</span>
  </div>
  <div class="container">
    <div *ngIf = "showSearch == true">
        <app-search-dialog (selectedSearchedItem)="handleSelectedUser($event)"  [isSearchTriggered]="false" [hideNotFoundButton]="true" [searchObject]="searchMemberObject" ></app-search-dialog>

    </div>
    <!-- <div class="row container-fluid member-info-search" *ngIf = "showAddUser == true" style="padding-top:0.3rem;" >
        <div class="row memberinfo">Add a New User</div>
        <div class="search-field-container">
          <form>
            <div class="row">
                <div class="col-4">
                    <label class="search-field-label">First Name</label>
                    <span class="star"> *</span> 
                    <input type="text" name="carrier" class="search-field"  [(ngModel)]="addMemberData.FirstName" >
                </div>
                <div class="col-4">
                    <label class="search-field-label">Last Name</label>
                    <span class="star"> *</span> <br />
                    <input type="text" name="name" class="search-field"  [(ngModel)]="addMemberData.LastName"/>
                </div>
                <div class="col"></div>
            </div>
            <div class="row">
                <div class="col-4">
                    <label class="search-field-label">Email Address</label>
                    <input type="email" name="email" class="search-field"  [(ngModel)]="addMemberData.Email">
                </div>
                <div class="col-4">
                    <label class="search-field-label">Telephone</label>
                    <input type="text" name="name" class="search-field"  [(ngModel)]="addMemberData.Phone"/>
                    
                </div>
                <div class="col"></div>
            </div>
            <div class="btn-wrapper mt-3 mb-3">
                <input  class="outline-btn ms-2" type="submit" value="Cancel" (click)="cancel()" />

                <input
                  class="main-btn ms-2"
                  type="submit"
                  value="Ok"
                  (click)="confirm()"
                />
               
              </div>
          </form>
        </div>
    </div>
    -->
  </div>

